import { render, staticRenderFns } from "./LessonEditorElements.vue?vue&type=template&id=0955bcba"
import script from "./LessonEditorElements.vue?vue&type=script&lang=js"
export * from "./LessonEditorElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports